<template>
    <div id="all">
        <!-- 首页图标 -->
        <!-- <div v-if="homeIcon === 'show'" class="return" :style="left" @click="returnHome">
            <img v-if="this.$route.name !== 'Brand'" class="return" src="/photo/icon/首页图标.png" alt="主页"/>
        </div> -->
        <!-- 组件传参 -->
        <router-view
            class="main"
            :softwareInfo="softwareInfo"
            @change="switchRouting"/>
    </div>
</template>
<script>
export default  {
    name: 'All',
    data () {
        return {
            // 时间戳
            timeStamp: 0,
            // 控制首页图标的显示、隐藏
            homeIcon: 'show',
            activeIndex: '1',
            // 存储接口返回的全部软件信息
            softwareInfoList: [],
            // 单个软件信息
            softwareInfo: {}
        }
    },
    created () {
        // 获取时间戳
        this.getTimeStamp()
        this.requestData()
    },
    methods: {
        // 获取时间戳
        getTimeStamp () {
            this.timeStamp = new Date().getTime()
            // console.log(this.timeStamp)
        },
        // 请求接口数据
        requestData () {
            this.$http.get('/mock/all.json', {
                params: {
                    timeStamp: this.timeStamp 
                }
            })
                .then((res) => {
                    this.softwareInfoList = res.data.data.softwareInfo
                    // 刷新页面重新传软件参数信息
                    this.softwareInfoList.forEach((element) => {
                        if (element.name === this.$route.name) {
                            this.softwareInfo = element
                            this.activeIndex = element.id
                        }
                    })
                })
        },
        switchRouting (value) {
            this.getData(value)
            if (value !== this.$route.name) {
                this.$router.push({ name: value })
            }
        },
        // 选择后品牌传递对应的软件参数信息
        getData (val) {
            this.softwareInfoList.forEach((element) => {
                if (element.name === val) {
                    this.softwareInfo = element
                }
            })
        },
        returnHome () {
            this.homeIcon = 'hide'
            this.$router.push({ name: 'Brand' })
        }
    }
}
</script>

<style lang="scss">
#all {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: column;
    height: 100vh;
    position: relative;
    .return {
        position: absolute;
        top: 8px;
        border-radius: 15px;
        cursor: pointer;
        img {
            width: 100px;
            height: 40px;
        }
    }
    .main {
      flex: 1;
    }
}
</style>
